import React from 'react';
import { Megaphone, Code2 } from 'lucide-react';
import { stats } from '../mock';

const Services = () => {
  return (
    <section className="bg-white">
      <div className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-12 items-center">
        <div className="order-2 md:order-1">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#2C5F66]/10 mb-6">
            <Megaphone size={40} className="text-[#2C5F66]" />
          </div>
          <h3 className="text-[#2C5F66] text-3xl md:text-4xl font-extrabold mb-6 leading-tight">
            TRADITIONAL MARKETING AND ADDITIONAL BUSINESS SERVICES
          </h3>
          <p className="text-gray-600 leading-relaxed text-[15px]">
            Traditional marketing and business services include <a href="#" className="text-[#D9A04A] hover:underline">video creation</a>, radio ad creation, billboard advertising, printing and production facilities, <a href="#" className="text-[#D9A04A] hover:underline">content writing</a>, proofreading, and more. If your business is looking for the best company to improve its advertising, marketing, and digital presence, reach out to our professional team today.
          </p>
        </div>
        <div className="order-1 md:order-2">
          <img
            src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=900&q=80"
            alt="Marketing services"
            className="rounded-lg shadow-xl w-full h-[360px] object-cover"
          />
        </div>
      </div>

      <div className="bg-[#F7F7F5]">
        <div className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src="https://images.unsplash.com/photo-1587440871875-191322ee64b0?w=900&q=80"
              alt="Web Design Services"
              className="rounded-lg shadow-xl w-full h-[360px] object-cover"
            />
          </div>
          <div>
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#D9A04A]/15 mb-6">
              <Code2 size={40} className="text-[#D9A04A]" />
            </div>
            <h3 className="text-[#2C5F66] text-3xl md:text-4xl font-extrabold mb-6 leading-tight">
              WEBSITE DESIGN AND DEVELOPMENT SERVICES
            </h3>
            <p className="text-gray-600 leading-relaxed text-[15px]">
              Developing a new website is a task all businesses need to address, and establishing an online reputation is no small undertaking. Start your new <a href="#" className="text-[#D9A04A] hover:underline">website development</a> on the right track, or you can find your business investing time and money for nothing. Launch your new website with today’s latest web technology and help ensure the long-term success of your business’s online presence.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-[#2C5F66]">
        <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-white text-4xl md:text-5xl font-extrabold">{s.value}</div>
              <div className="text-white/70 mt-2 text-sm tracking-wider">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
